import { isProd, isStaging } from "app/constants/env";

export type RouteTrackingEnvironment = "local" | "staging" | "production";

export type RouteTrackingTarget =
  | {
      type: "ido";
      ids: string[];
    }
  | {
      type: "quest";
      ids: string[];
    }
  | {
      type: "build_karma";
    };

export type RouteTrackingRule = {
  id: string;
  provider: "x";
  pixelId: string;
  enabled: boolean;
  activeFrom?: string;
  activeUntil: string;
  targets: RouteTrackingTarget[];
};

export const getRouteTrackingEnvironment = (): RouteTrackingEnvironment => {
  if (isProd()) {
    return "production";
  }

  if (isStaging()) {
    return "staging";
  }

  return "local";
};

export const routeTrackingConfig: Record<
  RouteTrackingEnvironment,
  RouteTrackingRule[]
> = {
  local: [],
  staging: [
    {
      id: "x-r0tux-ido-build-karma-staging",
      provider: "x",
      pixelId: "r0tux",
      enabled: true,
      activeFrom: "2026-06-06T14:00:12.000Z",
      activeUntil: "2026-06-20T14:00:12.000Z",
      targets: [
        { type: "ido", ids: ["6a2069a39436f7876e97df6c"] },
        { type: "build_karma" },
      ],
    },
  ],
  production: [
    {
      id: "x-r0tux-ido-build-karma-production",
      provider: "x",
      pixelId: "r0tux",
      enabled: true,
      activeFrom: "2026-06-06T14:00:12.000Z",
      activeUntil: "2026-06-20T14:00:12.000Z",
      targets: [
        { type: "ido", ids: ["6a2069a39436f7876e97df6c"] },
        { type: "build_karma" },
      ],
    },
  ],
};
